import React from 'react';
import './DecorativeLeaves.css';

// Decorative leaf configurations for different pages
export const leafConfigs = {
  hero: [
    // Bottom right corner
    { img: 'leaf1', position: 'bottom-right', size: 120, rotate: -15, offsetX: -120, offsetY: 0 },
    { img: 'leaf3', position: 'bottom-right', size: 80, rotate: 25, offsetX: -240, offsetY: 0 },
    // Top left corner
    { img: 'leaf2', position: 'bottom-left', size: 120, rotate: -15, offsetX: 100, offsetY: 0 },
    { img: 'leaf4', position: 'bottom-left', size: 80, rotate: 25, offsetX: 180, offsetY: 0 },
  ],
  creators: [
    { img: 'leaf1', position: 'top-left', size: 90, rotate: 0, offsetX: 0, offsetY: 310 },
    { img: 'leaf3', position: 'top-left', size: 100, rotate: 65, offsetX: 0, offsetY: 250 }
  ],
  about: [
    { img: 'leaf2', position: 'top-right', size: 110, rotate: 0, offsetX: 0, offsetY: 225 },
    { img: 'leaf1', position: 'top-right', size: 110, rotate: -40, offsetX: 0, offsetY: 175 }
  ],
  howToJoin: [
    { img: 'leaf1', position: 'top-right', size: 95, rotate: 0, offsetX: -50, offsetY: 235 }
  ],
  events: [
    { img: 'leaf1', position: 'top-left', size: 90, rotate: 0, offsetX: 0, offsetY: 310 },
    { img: 'leaf3', position: 'top-left', size: 100, rotate: 65, offsetX: 0, offsetY: 250 }
  ],
};

export default function DecorativeLeaves({ config = 'hero' }) {
  const leaves = leafConfigs[config] || leafConfigs.hero;

  return (
    <div className="decorative-leaves">
      {leaves.map((leaf, index) => (
        <div
          key={index}
          className={`decorative-leaf ${leaf.position}`}
          style={{
            '--leaf-size': `${leaf.size}px`,
            '--leaf-rotate': `${leaf.rotate}deg`,
            '--leaf-offset-x': `${leaf.offsetX}px`,
            '--leaf-offset-y': `${leaf.offsetY}px`,
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/leaves/${leaf.img}.png`}
            alt=""
            className="leaf-image"
          />
        </div>
      ))}
    </div>
  );
}
